import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import Toasted from 'vue-toasted';
 
Vue.config.productionTip = false
Vue.use(Toasted, {theme: "toasted-primary", 
  position: "top-center", 
  duration: 2500,
  iconPack: 'fontawesome'
})

/* Constantes */
window.DB_ADDR = 'https://procal.ipt.br:15984/'
window.WIN_SIZE = {w: null}
window.fnHandleResize = function () {
  var el = document.getElementById('pdf-container')
  if (el && el.style.display !== 'none') {
    var calcHeight = window.innerHeight - el.offsetTop - 16
    el.setAttribute('style','height:'+calcHeight+'px')
  }
  window.WIN_SIZE.w = window.innerWidth

}
window.addEventListener('resize', fnHandleResize)
fnHandleResize()


// Garante que o elemento que exibe o certificado 
// aparece apenas no momento certo
router.beforeEach((to, from, next) => {
  if (!from.params.id) {
    // primeiro limpa os dados, para indicação de loading
    INSTRUMENT_STORE.state.data.inst = null
  }
  var el = document.getElementById('pdf-container')
  if (!!el && (to.path.indexOf('/certificado') === -1 || !INSTRUMENT_STORE.state.db)) {
    el.style.display = 'none'
  } else {
    Object.assign(document.body.style, {
        overflow: '',
        marginRight: ''
    });
  }
  next()
})


new Vue({
  router,
  render: h => h(App)
}).$mount('#app')


// Analytics router
if (typeof window.ga === 'function') {
  router.afterEach(( to, from ) => {
    if (to.path === '/instrumentos') {
      document.title = 'ProCal'// + complementoPageView()
    }
    // window.setTimeout(() => {
    //   gtag('config', 'UA-121094153-1', {
    //     page_path: to.fullPath,
    //     app_name: 'ProCal',
    //     send_page_view: true
    //   });
    // }, 100)
  });
} else {
  console.log('ga off')
}

document.onkeydown = function(evt) {
  evt = evt || window.event;
  var isEscape = false;
  if ("key" in evt) {
      isEscape = (evt.key === "Escape" || evt.key === "Esc");
  } else {
      isEscape = (evt.keyCode === 27);
  }
  if (isEscape) {
    Object.keys(INSTRUMENT_STORE.state.modals).map((k) => {
      INSTRUMENT_STORE.state.modals[k] = false
    })
    
  }
};